<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>training</h1>
    </div>

    <div class="container">
      <br>
      <div class="row">
        <!-- Question Portion -->
        <div
          class="question-container"
          v-if="!done && !answered"
          >
          <div class="col-xs-12 text-center">
            <h1>Video Quiz</h1>
            <br>
            <p class="question-text">{{currentQuestion.text}}</p>
            <br><br>
          </div>
          <p class="prompt text-center">Click on one of the following answers.</p>
          <div class="question-answer-container col-xs-12">
            <div
              class="answer-container client-btn-primary clickable"
              v-if="answerExists(currentQuestion.answerOne)"
              @click.prevent="submitAnswer(currentQuestion.answerOne.correct)"
              >
              <div
                class="quiz-answer text-uppercase"
              >
                {{ currentQuestion.answerOne.text }}
              </div>
              <br>
            </div>
            <div
              class="answer-container client-btn-primary clickable"
              v-if="answerExists(currentQuestion.answerTwo)"
              @click.prevent="submitAnswer(currentQuestion.answerTwo.correct)"
              >
              <div
                class="quiz-answer text-uppercase"
              >
                {{ currentQuestion.answerTwo.text }}
              </div>
              <br>
            </div>
            <div
              class="answer-container client-btn-primary clickable"
              v-if="answerExists(currentQuestion.answerThree)"
              @click.prevent="submitAnswer(currentQuestion.answerThree.correct)"
              >
              <div
                class="quiz-answer text-uppercase"
              >
                {{ currentQuestion.answerThree.text }}
              </div>
              <br>
            </div>
            <div
              class="answer-container client-btn-primary clickable"
              v-if="answerExists(currentQuestion.answerFour)"
              @click.prevent="submitAnswer(currentQuestion.answerFour.correct)"
              >
              <div
                class="quiz-answer text-uppercase"
              >
                {{ currentQuestion.answerFour.text }}
              </div>
              <br>
            </div>
          </div>
        </div>
        <!-- Answer Portion -->
        <div
          v-if="!done && answered"
          class="answers-container">
          <div class="col-xs-12 text-center">
            <div :class="answerClasses">
              <strong>{{ correct ? 'Correct' : 'Incorrect' }}!</strong>
            </div>
            <h3>{{ currentQuestion.explanation }}</h3>
            <br><br>
          </div>
          <div class="col-xs-6 col-xs-offset-3">
            <a
              href=""
              type="button"
              class="btn client-btn-primary btn-lg btn-block text-uppercase"
              @click.prevent="nextQuestion"
            >
              Next
            </a>
            <br>
          </div>
        </div>
        <!-- Congrats -->
        <div
          v-if="done"
          class="answer-result-container"
          >
          <div class="col-xs-12 text-center">
            <div class="big-type text-uppercase grey-type"><strong>Congratulations!</strong></div>
            <h1 class="text-uppercase">You Have completed this training Module<br>
              and have earned {{ training.points }} Points.</h1>
            <br><br>
          </div>
          <div class="col-xs-8 col-xs-offset-2 col-md-6 col-md-offset-3">
            <router-link
              :to="{ name: 'EarnPoints', slug: this.$store.state.slug }"
              type="button"
              class="btn client-btn-primary btn-lg btn-block text-uppercase"
            >
              Back to earn points
            </router-link>
            <br>
          </div>
        </div>
      </div>
      <br>

      <br><br>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TrainingQuiz',
  props: ['training'],
  data () {
    return {
      currentQuestionIndex: 0,
      done: false,
      answered: false,
      correct: false
    }
  },
  computed: {
    ...mapState('user', ['user']),
    currentQuestion () {
      return this.training.questions[this.currentQuestionIndex]
    },
    answerClasses () {
      return 'big-type text-uppercase ' + (this.correct ? 'grey-type' : 'red-type')
    }
  },
  methods: {
    ...mapActions('user', ['completeTraining']),
    answerExists (answer) {
      return answer.text !== undefined && answer.text && answer.text.length > 0
    },
    goTrainingVideo () {
      this.$bus.emit('swapComponent', { component: 'training-video', props: { training: this.training } })
    },
    submitAnswer (isCorrect) {
      this.correct = isCorrect
      this.answered = true
    },
    nextQuestion () {
      // curr 0 length 1
      if (this.currentQuestionIndex + 1 < this.training.questions.length) {
        this.currentQuestionIndex++
        this.answered = false
      } else {
        this.done = true
        // update points
        const earnedPoints = this.training.points
        return this.completeTraining({
          id: this.user.userLoyaltyProgram._id,
          trainingId: this.training._id,
          userLoyaltyProgramParams: {
            totalPoints: this.user.userLoyaltyProgram.totalPoints + earnedPoints,
            currentPoints: this.user.userLoyaltyProgram.currentPoints + earnedPoints
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.question-answer-container {
  display: flex;
  justify-content: space-evenly;
  /* flex-wrap: wrap; */
  align-items: center;
  flex-direction: column;
}

.answer-container {
  width: 45%;
  border: 2px solid #2a2a2a;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 10px;
}

@media screen and (max-width: 687px) {
  .answer-container {
    width: 100%;
  }
}

.question-text {
  font-size: 2em;
}
</style>
